import request from '../utils/request'

// 获取目录列表
export function getModel(query) {
  return request({
    url: "/Category/GetCategoriesByLevel",
    method: "get",
    params: query
  });
}

// 根据id获取图片url
export function getUrl(id) {
  return request({
    url: `/Category/GetStaticResources/${id}`,
    method: "get",
  });
}

// 获取点击量前五的文章
export function getMoreText() {
  return request({
    url: "/Category/GetHotArticle",
    method: "get",
  });
}

// 获取最新文章
export function getNewText() {
  return request({
    url: "/Category/GetNewArticle",
    method: "get",
  });
}

// 获取搜索热词
export function getHot() {
  return request({
    url: "/Category/GetHotKeyWord",
    method: "get",
  });
}

// 更新搜索热词
export function updateHot(data) {
  return request({
    url: "/Category/UpdateKeyWord",
    method: "post",
    data: data
  });
}

// 根据id获取下面的目录结构
export function getCont(id) {
  return request({
    url: `/Category/GetInfoByCategory/${id}`,
    method: "get",
  });
}

// 根据id获取文章信息
export function getText(id) {
  return request({
    url: `/Category/FindArticle/${id}`,
    method: "get",
  });
}

// // 根据标题查找文章
// export function getTextCont(id) {
//   return request({
//     url: `/Category/FindArticle/${id}`,
//     method: "get",
//   });
// }

// 根据关键词搜索文章
export function getHotText(data) {
  return request({
    url: '/Category/SearchArticle',
    method: "post",
    data: data
  })
}
